const documentApiUrl = process.env.REACT_APP_DATAROOM_API_URL || 'https://virgate-data-room-dev.azurewebsites.net/api';

export default documentApiUrl 